module.exports = __webpack_public_path__ + "static/ziggy_video-0333acf5136a62d716a91466fa687b62.jpg";